import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createRef, memo, useCallback, useEffect, useMemo, useRef, useState, } from 'react';
import * as $ from 'jquery';
import { GraphBlockSet } from './components/graph/block-set';
import { APILoaderProvider } from './components/graph/loader';
import { graph_block_unserialize, GraphBlock } from './components/graph';
import { isMobileApp } from 'webui/utils/version';
import { preventDefault } from 'shared/hooks/utils';
import { any2unixtime, todayEnd, todayStart } from 'webui/utils/time';
import './styles/graphs-tab.sass';
import 'console/tabs/graphs/_cards.sass';
import { useGraphDialog } from './components/graph/hooks/useGraphDialog';
import { all_default_graph_sources } from './components/graph/dialog';
import { useGraphDeleteDialog } from './components/graph/hooks/useGraphDelete';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { selectThemeType } from 'console/theme/selector';
import { getEffectiveThemeMode } from 'console/theme/styles/dark-theme';
import { EffectiveThemeType } from 'console/theme/types';
import { createSelector } from '@reduxjs/toolkit';
import SyncIcon from '@mui/icons-material/Sync';
import SyncDisabledIcon from '@mui/icons-material/SyncDisabled';
import { onPushFullScreen } from 'shared/map/ui/components/control-buttons/components/fullscreen/lib';
import { setPeriod } from 'console/period/actions';
import { throttle } from 'throttle-debounce';
import 'jquery-ui/ui/widgets/sortable';
import { PeriodWidget } from 'console/period';
import { isSmallUI } from 'shared/app/lib/choose-ui-type';
import { getStaleState } from 'console/idle/selectors';
import { useBooleanState } from 'shared/hooks/state/boolean';
const graph_container = $(`
    <div class="ui-graphs-tab-scrolling-area">
        <div class="ui-graphs-tab-empty-container disable">
            <div class="ui-graphs-tab-empty-line"></div>
            <div class="ui-graphs-tab-empty-blockset">Нет выбранных графиков</div>
        </div>
    </div>
`);
const _block_actions = [
    { id: 'edit', title: 'изменить график', icon_class: 'edit' },
    { id: 'full_screen', title: 'на весь экран', icon_class: 'full_screen' },
    { id: 'print', title: 'распечатать график', icon_class: 'print' },
    { id: 'delete', title: 'удалить график', icon_class: 'delete' },
    {
        id: 'sort_handle',
        title: 'поменять расположение графика',
        icon_class: 'sort_handle',
    },
];
const isDarkMode = createSelector(selectThemeType, (user_theme_type) => getEffectiveThemeMode(user_theme_type) == EffectiveThemeType.DARK);
function set_period_from_unixtime(value) {
    return [new Date(value.mintime * 1e3), new Date(value.maxtime * 1e3)];
}
export const GraphsTabContent = memo(function GraphsTabContent(props) {
    const { ui, r_device, device, active } = props;
    const is_dark_mode = useAppSelector(isDarkMode);
    const period = useAppSelector((state) => state.period);
    const onSetPeriod = useAction(setPeriod);
    const [func_call_key, setFuncCallKey] = useState(null);
    const [wheel_zoom_all, , , setWheelZoomAll] = useBooleanState(ui.settings.data()?.graphs?.wheel_zoom_all ?? true);
    const [wheel_zoom, setWheelZoom] = useState(ui.settings.data()?.graphs?.wheel_zoom ?? true);
    const reference = useRef(null);
    const ref_full_screen = createRef();
    const [GraphDialog, openGraphDialog] = useGraphDialog();
    const [GraphDeleteDialog, openGraphDeleteDialog] = useGraphDeleteDialog();
    const _block_set = useMemo(() => {
        return new GraphBlockSet(new APILoaderProvider(ui, ui.api, device), ui);
    }, [r_device.id]);
    const stale = useAppSelector(getStaleState);
    useEffect(() => {
        if (reference.current) {
            graph_container.appendTo(reference.current);
        }
        _block_set.element().appendTo(graph_container);
        if (reference.current && period != null) {
            const new_period = set_period_from_unixtime(period);
            _block_set.period(new_period);
        }
        if (_block_set) {
            _block_set.set_wheel_zoom(wheel_zoom);
        }
        _block_set.set_wheel_zoom_all(wheel_zoom_all);
        activated();
        window.addEventListener('orientationchange', () => _block_set.full_screen_block_resize());
        $('.ui-graphs-tab-scrolling-area').on('scroll', throttle(200, () => {
            for (const block of _block_set._graph_blocks) {
                block.redraw();
            }
        }));
        $('.ui-graph-container').on('mouseleave', () => {
            for (const block of _block_set._graph_blocks) {
                block.redraw();
            }
        });
        $('.ui-graphs-container').sortable({
            scrollSensitivity: 30,
            scrollSpeed: 15,
            scroll: true,
            tolerance: 'intersect',
            axis: 'y',
            cursor: 'move',
            handle: '.sort_handle',
            opacity: 0.5,
            placeholder: 'sort-handle-default-block',
            forcePlaceholderSize: true,
            start: startSortable,
            update: updateSortable,
        });
        return () => {
            const el = reference.current?.querySelector('.ui-graphs-tab-scrolling-area');
            if (el) {
                reference.current?.removeChild(el);
            }
            $('.ui-graphs-container').sortable('destroy');
            destroy();
            window.removeEventListener('orientationchange', () => _block_set.full_screen_block_resize());
        };
    }, [_block_set]);
    useEffect(() => {
        if (active && !stale) {
            _reload();
        }
    }, [stale]);
    useEffect(() => {
        if (reference.current && _block_set) {
            _block_set.period(set_period_from_unixtime(period));
            _reload();
        }
    }, [period]);
    useEffect(() => {
        if (reference.current && _block_set) {
            _reload();
        }
    }, [is_dark_mode]);
    useEffect(() => {
        if (active && reference.current && _block_set) {
            _block_set._align_graphs();
        }
    }, [active]);
    useEffect(() => {
        window.addEventListener('orientationchange', () => _block_set.full_screen_block_resize());
        return () => window.removeEventListener('orientationchange', () => _block_set.full_screen_block_resize());
    }, []);
    const block_resize = () => {
        _save();
    };
    const startSortable = (event, ui) => {
        $('.ui-graphs-tab-scrolling-area').off('scroll');
        for (const block of _block_set._graph_blocks)
            block.redraw();
    };
    const updateSortable = (event, ui) => {
        const sortedIDs = $('.ui-graphs-container')
            .sortable('toArray')
            .filter((el) => el !== '');
        const new_config = sortedIDs.map((el, idx) => {
            const needed_block = _block_set._graph_blocks[parseInt(el)];
            needed_block._element.attr('id', idx);
            needed_block._graph._resize_sensor?.reset();
            return needed_block;
        });
        _block_set._graph_blocks = new_config;
        _save();
        $('.ui-graphs-tab-scrolling-area').on('scroll', throttle(100, () => {
            for (const block of _block_set._graph_blocks)
                block.redraw();
        }));
    };
    const fullscreenMode = (block) => {
        //@ts-ignore
        const isFullScreen = !document.webkitIsFullScreen && !document.mozFullScreen;
        if (block.full_screen() && isFullScreen) {
            resizeBlockOnClose(block);
        }
    };
    const block_action = (block, action) => {
        switch (action) {
            case 'edit':
                if (block.full_screen()) {
                    fullScreenClose(block);
                }
                _openEditGraphDialoG(block);
                break;
            case 'delete':
                if (block.full_screen()) {
                    fullScreenClose(block);
                }
                _openDEleteGraphDialog(block);
                break;
            case 'print':
                if (block.full_screen()) {
                    fullScreenClose(block);
                }
                _on_print_graphs(block);
                break;
            case 'full_screen':
                if (block.full_screen()) {
                    fullScreenClose(block);
                }
                else {
                    fullScreenOpen(block);
                }
                document.addEventListener('fullscreenchange', () => fullscreenMode(block));
                break;
            default:
                break;
        }
    };
    const destroy = () => {
        _block_set.destroy();
    };
    const activated = () => {
        _restore();
        window.setImmediate(() => _redraw());
    };
    const _add_block = (block, index) => {
        _block_set.add_block(block, index);
    };
    const _instantiate_block = (sources, title_block, show_tooltip, show_legend, bool_graph_on_main, size_boolean_line, height_medium = null, height_mobile = null) => {
        return new GraphBlock(sources, _block_actions, height_medium, height_mobile, block_action, yaxis_changed, block_resize, set_hover, set_unhover, view_port_change, title_block, show_tooltip, show_legend, size_boolean_line, bool_graph_on_main);
    };
    const _on_print_graphs = async (block = null) => {
        const print_button_all_graphs = graph_container.find('.ui-graphs-print');
        const print_button_one_graph = graph_container.find('.ui-graph-block-action');
        print_button_all_graphs.css('pointer-events', 'none');
        print_button_all_graphs.find('.ui-icon-graph-print').addClass('disable');
        print_button_all_graphs.find('.text').text('идет печать...');
        print_button_all_graphs.find('.text').addClass('disable');
        print_button_one_graph.css('pointer-events', 'none');
        print_button_one_graph.find('.print').addClass('disable');
        try {
            await _block_set.print_graphs(block);
        }
        catch (e) {
            console.error('Error when print graphics ', e);
        }
        finally {
            const print_button_all_graphs = graph_container.find('.ui-graphs-print');
            const print_button_one_graph = graph_container.find('.ui-graph-block-action');
            print_button_all_graphs.css('pointer-events', 'auto');
            print_button_all_graphs.find('.ui-icon-graph-print').removeClass('disable');
            print_button_all_graphs.find('.text').text('печать графиков');
            print_button_all_graphs.find('.text').removeClass('disable');
            print_button_one_graph.css('pointer-events', 'auto');
            print_button_one_graph.find('.print').removeClass('disable');
        }
    };
    const _redraw = () => {
        if (period != null) {
            _block_set.period(set_period_from_unixtime(period));
        }
        _block_set?.redraw();
        onSetPeriod(period.mintime, period.maxtime);
    };
    const _reload = () => _block_set.reload();
    const serialize = () => {
        return { blocks: _block_set.serialize() };
    };
    const _save = () => {
        device.updateSettings({ graphs_config: serialize() });
    };
    const empty_blockset = (value) => {
        const ui_block = graph_container.find('.ui-graphs-tab-empty-container');
        if (value === 'set')
            ui_block.removeClass('disable');
        if (value === 'remove')
            ui_block.addClass('disable');
    };
    const _restore = () => {
        let config = device.graphs_config();
        if (config == null) {
            const sources = all_default_graph_sources(device);
            const yaxes_keys = [];
            const yaxes_keys_dict = {};
            for (const src of sources) {
                const key = src.yaxis_key();
                if (key && !(key in yaxes_keys_dict)) {
                    //@ts-ignore
                    yaxes_keys_dict[key] = true;
                    yaxes_keys.push(key);
                }
            }
            config = {
                blocks: yaxes_keys
                    .filter((yaxis_key) => yaxis_key != null)
                    .map((yaxis_key) => ({
                    sources: sources
                        .filter((src) => [undefined, yaxis_key].includes(src.yaxis_key()))
                        .map((src) => src.serialize()),
                    show_tooltip: false,
                    show_legend: true,
                    size_boolean_line: 5,
                    bool_graph_on_main: false,
                })),
            };
        }
        const blocks = config.blocks ?? [];
        _block_set.clear();
        if (blocks.length === 0) {
            empty_blockset('set');
        }
        if (blocks.length > 0) {
            empty_blockset('remove');
        }
        blocks.forEach((block_config, idx) => {
            _add_block(graph_block_unserialize(device, _block_actions, block_config, block_action, yaxis_changed, block_resize, set_hover, set_unhover, view_port_change), idx);
        });
        _reload();
    };
    const _update_wheel_toggle = useCallback(() => {
        if (_block_set)
            _block_set.set_wheel_zoom(!wheel_zoom);
        ui.settings.set({
            graphs: { wheel_zoom: !wheel_zoom, wheel_zoom_all: wheel_zoom_all },
        });
        setWheelZoom(!wheel_zoom);
    }, [wheel_zoom, _block_set, setWheelZoom]);
    const yaxis_changed = () => {
        _block_set._align_graphs();
    };
    const set_hover = (time, position) => {
        _block_set.hover(time, position);
    };
    const view_port_change = (value, position, no_event) => {
        _block_set.view_port_change(value, position, no_event);
    };
    const set_unhover = () => {
        _block_set.unhover();
    };
    const _changeWheelZoomAll = useCallback((e) => {
        preventDefault(e);
        ui.settings.set({ graphs: { wheel_zoom_all: !wheel_zoom_all } });
        _block_set.set_wheel_zoom_all(!wheel_zoom_all);
        setWheelZoomAll();
    }, [wheel_zoom_all, setWheelZoomAll]);
    const _openDEleteGraphDialog = useCallback((block) => {
        openGraphDeleteDialog(block);
    }, [openGraphDeleteDialog]);
    const _openEditGraphDialoG = useCallback((block) => {
        if (block) {
            setFuncCallKey('edit');
            openGraphDialog(block);
        }
    }, [setFuncCallKey, openGraphDialog]);
    const _openNewGraphDialoG = useCallback((e) => {
        preventDefault(e);
        setFuncCallKey('add_new');
        openGraphDialog(undefined);
    }, [setFuncCallKey, openGraphDialog]);
    const ConfirmDialogGraph = (sources, block, title_block, show_tooltip, show_legend, size_boolean_line, bool_graph_on_main) => {
        if (func_call_key === 'add_new') {
            _add_block(_instantiate_block(sources, title_block, show_tooltip, show_legend, bool_graph_on_main, size_boolean_line), _block_set._graph_blocks.length);
            empty_blockset('remove');
            _reload();
            _save();
        }
        if (func_call_key === 'edit' && block) {
            _block_set.replace_block(block, _instantiate_block(sources, title_block, show_tooltip, show_legend, bool_graph_on_main, size_boolean_line, ...block.get_heights()));
            _save();
        }
    };
    const ConfirmDeleteDialog = (block) => {
        _block_set.delete_block(block);
        if (_block_set._graph_blocks.length === 0)
            empty_blockset('set');
        _save();
    };
    const resizeBlockOnClose = useCallback((block) => {
        const current_block = block.element()[0];
        if (current_block) {
            block.set_full_screen(false);
            block.resize();
            block._remove_tooltip();
            graph_container.find('.full_screen').removeClass('on');
            graph_container.find('.sort_handle').removeClass('disable');
        }
    }, []);
    const fullScreenClose = useCallback((block) => {
        const current_block = block.element()[0];
        if (current_block) {
            onPushFullScreen(current_block);
            resizeBlockOnClose(block);
        }
    }, []);
    const fullScreenOpen = useCallback((block) => {
        const current_block = block.element()[0];
        if (current_block) {
            block.set_full_screen(true);
            onPushFullScreen(current_block);
            block.resize();
            block._setup_tooltip();
            graph_container.find('.full_screen').addClass('on');
            graph_container.find('.sort_handle').addClass('disable');
        }
    }, []);
    return (_jsxs("div", { className: "mobile-tabs-tab-socket-old-adapter", ref: ref_full_screen, children: [_jsx("div", { className: "ui-bottom-tab ui-graphs-tab-zn visible", children: _jsx("div", { className: "ui-graphs-paper", ref: reference, children: _jsxs("div", { className: "ui-graphs-toolbar", children: [_jsx(PeriodWidget, { mintime: period.mintime ?? any2unixtime(todayStart()), maxtime: period.maxtime ?? any2unixtime(todayEnd()), onDatesSelected: onSetPeriod }), _jsxs("div", { className: "ui-graphs-toolbar-controls", children: [_jsxs("a", { href: "#", className: "ui-graphs-add ui-graphs-control-link", role: "add-graph", onClick: _openNewGraphDialoG, children: [_jsx("span", { className: "ui-icon-graph-control-add" }), _jsxs("span", { children: ["\u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C", _jsx("span", { className: "hide-if-narrow", children: " \u0433\u0440\u0430\u0444\u0438\u043A" })] })] }), !isMobileApp() && !isSmallUI() && (_jsxs("a", { href: "#", className: "ui-graphs-wheel-toggle ui-graphs-control-link", onClick: _update_wheel_toggle, children: [_jsx("span", { role: "icon", className: wheel_zoom
                                                    ? 'ui-icon-graph-wheel-zoom'
                                                    : 'ui-icon-graph-wheel-scroll' }), _jsx("span", { role: "text", children: wheel_zoom ? 'масштаб' : 'прокрутка' })] })), wheel_zoom && (_jsxs("a", { href: "#", className: "ui-all-graphs-wheel-toggle ui-graphs-control-link", onClick: _changeWheelZoomAll, children: [wheel_zoom_all ? (_jsx(SyncIcon, {})) : (_jsx(SyncDisabledIcon, {})), _jsx("span", { role: "text", children: wheel_zoom_all ? 'все' : 'выбранный' })] })), !isMobileApp() && !isSmallUI() && (_jsxs("a", { href: "#", className: "ui-graphs-print ui-graphs-control-link", role: "print-graphs", onClick: () => _on_print_graphs(), children: [_jsx("span", { role: "icon", className: "ui-icon-graph-print" }), _jsx("span", { className: "text", children: "\u043F\u0435\u0447\u0430\u0442\u044C \u0433\u0440\u0430\u0444\u0438\u043A\u043E\u0432" })] }))] })] }) }) }), _jsx(GraphDialog, { onConfirm: ConfirmDialogGraph, device: device }), _jsx(GraphDeleteDialog, { onConfirm: ConfirmDeleteDialog })] }));
});
